import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppService } from '../app.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

  constructor(private serv: AppService, private route: ActivatedRoute) { }

  token = ""

  resetPassFormGroup = new FormGroup({
    password: new FormControl(''),
    confirmPassword: new FormControl('')
  })

  wrongInput = false
  wrongInputReason = ""


  done = false

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.token = params['token']
    })
  }

  onSubmit() {
    let password = this.resetPassFormGroup.get('password').value
    let confirmPassword = this.resetPassFormGroup.get('confirmPassword').value

    if (!password || password.length == 0) {
      this.wrongInput = true
      this.wrongInputReason = "Indtast kodeord!"
      return
    }

    if (password != confirmPassword) {
      this.wrongInput = true
      this.wrongInputReason = "De to indtastede kodeord skal være ens!"
      return
    }

    this.serv.resetPassword(this.resetPassFormGroup.get('password').value, this.token).subscribe( ret => {
      if (!ret['result']) {
        this.wrongInput = true
        this.wrongInputReason = ret['reason']
      } else {
        this.done = true
      }
    })
  }

}
